import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/PartyAddressDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class PartyAddressEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddress/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class PartyAddressFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public partyId: IFieldOptions = { field: "partyId" };
	public typeId: IFieldOptions = { field: "typeId" };
	public field1: IFieldOptions = { field: "field1" };
	public field2: IFieldOptions = { field: "field2" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public status: IFieldOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.field1);
		this.push(this.field2);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyAddressForm implements IFormOptions {
	protected partyAddressFormName: string = "partyAddressForm";
	protected partyAddressFormModel: models.PartyAddressDTO = new models.PartyAddressDTO();
	protected partyAddressFormEndPoints: PartyAddressEndPoints = new PartyAddressEndPoints();
	protected partyAddressFormFields: PartyAddressFormFields = new PartyAddressFormFields();
	public get name(): string { return this.partyAddressFormName };
	public get model(): models.PartyAddressDTO { return this.partyAddressFormModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressFormEndPoints };
       public set endPoints(partyAddressEndPoints: IEntityEndPoints) {
		this.partyAddressFormEndPoints = partyAddressEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): PartyAddressFormFields { return this.partyAddressFormFields };
}

export class PartyAddressListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public partyId: IColumnOptions = { field: "partyId" };
	public typeId: IColumnOptions = { field: "typeId" };
	public field1: IColumnOptions = { field: "field1" };
	public field2: IColumnOptions = { field: "field2" };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public status: IColumnOptions = { field: "status" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.partyId);
		this.push(this.typeId);
		this.push(this.field1);
		this.push(this.field2);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
	}
}

export class PartyAddressList implements IGridOptions {
	protected partyAddressListName: string = "partyAddressList";
	protected partyAddressListModel: models.PartyAddressDTO = new models.PartyAddressDTO();
	protected partyAddressListEndPoints: PartyAddressEndPoints = new PartyAddressEndPoints();
	protected partyAddressListColumns: PartyAddressListColumns = new PartyAddressListColumns();
	public partyAddressForm: PartyAddressForm = new PartyAddressForm();
	public get name(): string { return this.partyAddressListName };
	public get model(): models.PartyAddressDTO { return this.partyAddressListModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressListEndPoints };
	public set endPoints(partyAddressEndPoints: IEntityEndPoints) {
		this.partyAddressListEndPoints = partyAddressEndPoints;
		this.partyAddressForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): PartyAddressListColumns { return this.partyAddressListColumns };
}

export class PartyAddressEntity implements IEntityOptions {
	protected partyAddressEntityName: string = "partyAddressEntity";
	protected partyAddressEntityModel: models.PartyAddressDTO = new models.PartyAddressDTO();
	protected partyAddressEntityEndPoints: PartyAddressEndPoints = new PartyAddressEndPoints();
	protected partyAddressEntityList: PartyAddressList = new PartyAddressList();
	public get name(): string { return this.partyAddressEntityName };
	public get model(): models.PartyAddressDTO { return this.partyAddressEntityModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressEntityEndPoints };
	public set endPoints(partyAddressEndPoints: IEntityEndPoints) {
		this.partyAddressEntityEndPoints = partyAddressEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): PartyAddressList { return this.partyAddressEntityList };
	public get form(): PartyAddressForm { return this.grid.partyAddressForm };
	constructor(name?: string) {
		if (name) this.partyAddressEntityName = name;
		this.endPoints = this.partyAddressEntityEndPoints;
	}
};
//export class PartyAddressGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: PartyAddressForm = new PartyAddressForm();
//};

//export class PartyAddressListPageComponent extends ListPageComponent {
  //protected listPageComponentList: PartyAddressList = new  PartyAddressList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class PartyAddressBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyAddressGeneratedForm}];
//};

//export class PartyAddressListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyAddressListPageComponent, isMenuHidden: true }];
//};

